import { capitalizeAllWords } from "../../utils/stringUtils"
import EllipsisText from "../../components/EllipsisText"
import WaitTime from "../../components/WaitTime"
import Icon from "../../components/Icon"
import ClickablePhoneNumber from "../../components/ClickablePhoneNumber";
import { FULFILLMENT_METHOD_PICKUP } from "../../constants/payeeOrder"
import {StoreIcon, DeliveryIcon} from  "../../constants/serverImages"

const OrderingFulfillmentDetails = ({location={}, waitTimes={}, fulfillmentMethod=FULFILLMENT_METHOD_PICKUP, IconImg=null, phoneIsActive=false}) => {
    const {name:locationName="", line1="", line2="", countryName="", city="", directions="", contactNumber=""} = location || {}
    const {avg="", buffer=""} = waitTimes || {}
    IconImg = IconImg ? IconImg :
                    fulfillmentMethod === FULFILLMENT_METHOD_PICKUP ? 
                    StoreIcon : DeliveryIcon
    
    return (
        <div className="card dark display-flex align-items-center font-size-14px text-align-left">
            <div className="margin-right-1em">
            <img src={IconImg} height={40} width={40}/>
            </div>
            <div>
                {locationName ? <div>{locationName}</div> : null}
                {line1 ? <div>{line1}</div> : null}
                {line2 ? <div>{line2}</div> : null}
                <div>{city ?`${capitalizeAllWords(city)}, `: null}{countryName ? capitalizeAllWords(countryName) : null}</div>
                {
                    contactNumber ? 
                    <div>
                        {
                            phoneIsActive ?
                            <ClickablePhoneNumber 
                                phoneNumber={contactNumber}
                                phoneLabel={`Call ${locationName}`}
                                whatsappLabel={`Whatsapp ${locationName}`}
                                whatsappMessage={`Hi, ${locationName}`}
                            />
                            :
                            contactNumber
                        }
                    </div> 
                    : 
                    null
                }
                {
                    directions ? 
                    <div className="margin-top-5px">
                        <div className="font-weight-500">Directions</div>
                        <div className="color-grey"><EllipsisText text={directions} /></div>
                    </div>
                    :
                    null
                }
                {
                    avg ?
                    <div className="margin-top-1em display-flex align-items-center">
                         <Icon icon="schedule"/>
                         <span className="margin-right-05em" />
                         <WaitTime avg={avg} buffer={buffer} label={`${fulfillmentMethod === FULFILLMENT_METHOD_PICKUP ?"Pick up in": "Delivery in"}`}/>
                    </div>
                    : 
                    null
                }
            </div>
            
            
        </div>
    )
}

export default OrderingFulfillmentDetails